import React, { Component } from 'react';
import './Footer.scss';

class Footer extends Component {

  constructor() {
    super();
    this.state = {

    };
  }

  render() {
    return (
      <div className="websitefooter-container">  </div>
    );
  }
}

export default Footer;






// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js